import styled from 'styled-components'

export const Content = styled.section`
  text-align: center;
`
